var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "./IconContainer";
const CheckCircleIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({ className: classNames("gerudo-icon-check-circle", size, className) }, props),
        React.createElement("title", null, title),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.0", viewBox: "0 0 24 24", role: "img", "aria-label": title },
            React.createElement("title", null, title),
            React.createElement("circle", { shapeRendering: "geometricPrecision", cx: "12", cy: "12", r: "11", fill: "currentColor", role: "presentation" }),
            React.createElement("path", { shapeRendering: "geometricPrecision", d: "M12,2A10,10,0,1,1,2,12,10.011,10.011,0,0,1,12,2m0-2A12,12,0,1,0,24,12,12,12,0,0,0,12,0Z", fill: "currentColor", role: "presentation" }),
            React.createElement("polyline", { strokeMiterlimit: "10", points: "19.5 7.5 9.5 16.5 4.5 12", fill: "none", stroke: "#fff", strokeWidth: "3px" // todo : check with designer the width and the stroke
                , role: "presentation" }))));
};
CheckCircleIcon.defaultProps = {
    title: "Check",
};
export default CheckCircleIcon;
export { CheckCircleIcon };
//# sourceMappingURL=CheckCircle.js.map